import { Directive, Input, TemplateRef, ViewContainerRef, inject } from '@angular/core';

@Directive({
    selector: '[ngVar]',
    standalone: false
})
export class VarDirective {
    private templateRef = inject<TemplateRef<any>>(TemplateRef);
    private vcRef = inject(ViewContainerRef);

    @Input() set ngVar(context: any) {
        this.context.$implicit = this.context.ngVar = context;

        if (!this.hasView) {
            this.vcRef.createEmbeddedView(this.templateRef, this.context);
            this.hasView = true;
        }
    }

    private context: {
        $implicit: any;
        ngVar: any;
    } = {
            $implicit: null,
            ngVar: null,
        };

    private hasView: boolean = false;


    constructor() { }
}